<template>
  <div class="step">
    <div class="step__section step__section--niche-card">
      <div class="step__title">Карточка ниши</div>
      <NicheCard
        class="step__section--niche-card__card"
        :title="asideDataClone.stepData.niche.niche.name"
        :description="`${asideDataClone.stepData.niche.niche.facultiesQuantity || 'N'} сборных`"
        :icon="
          asideDataClone.stepData.niche.niche.customIconBlob ||
          asideDataClone.stepData.niche.niche.icon
        "
        :bg="asideDataClone.stepData.niche.niche.background"
      />
    </div>
    <div class="step__section step__section--niche-card-settings">
      <div class="step__section--niche-card-settings__item">
        <div class="step__section--niche-card-settings__title">Фон</div>
        <div class="step__section--niche-card-settings__card">
          <div
            class="step__section--niche-card-settings__card-bg"
            :style="{ backgroundColor: asideDataClone.stepData.niche.niche.background }"
          />
          <input
            v-model="asideDataClone.stepData.niche.niche.background"
            type="color"
            list="niche-preset-colors"
          />
          <datalist id="niche-preset-colors">
            <option>#6979F8</option>
            <option>#00B0E8</option>
            <option>#9757FF</option>
            <option>#F39200</option>
            <option>#EB5757</option>
            <option>#DF3FF9</option>
            <option>#B8B8BE</option>
            <option>#2DC14E</option>
            <option>#FF5C00</option>
            <option>#3040C2</option>
          </datalist>
        </div>
      </div>
      <div class="step__section--niche-card-settings__item">
        <div class="step__section--niche-card-settings__title">
          Эмблема <span class="required">*</span>
        </div>
        <div class="step__section--niche-card-settings__item--icon">
          <div
            v-if="!asideDataClone.stepData.niche.niche.customIcon"
            class="step__section--niche-card-settings__card"
            @click="uploadCustomNicheIcon"
          >
            <DownloadIcon />
          </div>
          <div
            v-if="asideDataClone.stepData.niche.niche.customIcon"
            class="step__section--niche-card-settings__card"
            @click="deleteCustomNicheIcon"
          >
            <DeleteIcon2 />
          </div>
          <div class="step__section--niche-card-settings__item__text">
            <div
              v-if="asideDataClone.stepData.niche.niche.customIcon"
              class="step__section--niche-card-settings__item__text__title"
            >
              {{ asideDataClone.stepData.niche.niche.customIcon.name }}
            </div>
            <div v-else class="step__section--niche-card-settings__item__text--placeholder">
              Загрузи SVG или PNG файл размера 72х72 px белого цвета
            </div>
            <div class="step__section--niche-card-settings__item__text__description">
              {{ readableCustomNicheIconSize }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="step__section step__section--niche">
      <div class="step__title">О нише</div>
      <Input
        v-model="asideDataClone.stepData.niche.niche.name"
        type="text"
        :error="!validations.nicheName.value && asideDataClone.stepData.niche.nicheNameIsDirty"
        :error-message="validations.nicheName.error"
        required
        label="Название"
        placeholder="Укажи название ниши"
      />
      <Select
        v-model="asideDataClone.stepData.niche.niche.area"
        :options="asideDataClone.stepData.niche.options.areas"
        option-text="name"
        option-key="id"
        opacity
        label="Сфера"
        placeholder="Укажи сферу"
        required
      />
      <Select
        v-model="asideDataClone.stepData.niche.niche.parent"
        :options="asideDataClone.stepData.niche.options.categories"
        option-text="name"
        option-key="id"
        opacity
        label="Категория"
        placeholder="К какой категории по вложениям отосится сборная"
        required
      />
    </div>
  </div>
</template>

<script>
import { cloneDeep } from 'lodash';
import selectFile from '@/functions/selectFile';
import readableBytes from '@/functions/readableBytes';
import Input from '@/components/UiKit/v2/Input';
import Select from '@/components/UiKit/v2/Select';
import NicheCard from '@/components/UiKit/v2/NicheCard';
import DeleteIcon2 from '@/components/Icons/DeleteIcon2.vue';
import DownloadIcon from '@/components/Icons/DownloadIcon.vue';

export default {
  name: 'NicheForm',
  components: {
    Input,
    NicheCard,
    Select,
    DeleteIcon2,
    DownloadIcon
  },
  props: {
    mode: {
      type: String,
      default: ''
    },
    asideData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      asideDataClone: {}
    };
  },
  computed: {
    stepIsValid() {
      return Object.values(this.validations).every(item => item.value);
    },
    validations() {
      return {
        nicheName: this.validateNicheName,
        nicheIcon: this.validateNicheIcon,
        nicheMeta: this.validateMeta
      };
    },
    validateNicheName() {
      const result = {
        value: true,
        error: ''
      };
      const nicheNameIsEmpty =
        this.asideData.stepData.niche.niche.name === '' &&
        !this.asideData.stepData.niche.nicheNameIsDirty;
      const nicheNameLengthIsValid =
        this.asideData.stepData.niche.niche.name.length <=
        this.asideData.stepData.niche.nicheNameMaxLength;
      const nicheNameIsValid = this.asideData.stepData.niche.niche.name.length > 0;

      if (!nicheNameIsValid || nicheNameIsEmpty) {
        result.value = false;
        result.error = 'Введите название ниши';
      }
      if (!nicheNameLengthIsValid) {
        result.value = false;
        result.error = 'Максимум 60 символов';
      }
      return result;
    },
    validateNicheIcon() {
      const result = {
        value: true,
        error: ''
      };
      const nicheIconUploaded =
        this.asideData.stepData.niche.niche.customIcon.size ||
        this.asideData.stepData.niche.niche.icon;

      if (!nicheIconUploaded) {
        result.value = false;
        result.error = 'Загрузите эмблему';
      }
      return result;
    },
    validateMeta() {
      return {
        value:
          this.asideData.stepData.niche.niche.area.id !== 0 &&
          this.asideData.stepData.niche.niche.parent.id !== 0,
        error: ''
      };
    },
    readableCustomNicheIconSize() {
      return this.asideDataClone.stepData.niche.niche.customIcon.size
        ? readableBytes(this.asideDataClone.stepData.niche.niche.customIcon.size)
        : '';
    }
  },
  watch: {
    stepIsValid(value) {
      this.asideDataClone.isValid = value;
    },
    asideDataClone: {
      deep: true,
      handler() {
        this.$emit('update:asideData', this.asideDataClone);
      }
    },
    'asideData.stepData.niche.inputs.niche.name'() {
      this.asideDataClone.stepData.niche.nicheNameIsDirty = true;
    }
  },
  created() {
    this.asideDataClone = cloneDeep(this.asideData);
    this.asideDataClone.isValid = this.stepIsValid;
  },
  methods: {
    async uploadCustomNicheIcon() {
      if (!this.asideDataClone.stepData.niche.niche.customIcon) {
        this.asideDataClone.stepData.niche.niche.customIcon = await selectFile('image/*', false);
        this.asideDataClone.stepData.niche.niche.customIconBlob = URL.createObjectURL(
          this.asideDataClone.stepData.niche.niche.customIcon
        );
      }
    },
    deleteCustomNicheIcon() {
      this.asideDataClone.stepData.niche.niche.customIcon = '';
    }
  }
};
</script>

<style lang="scss" scoped>
@import 'src/style/utils';

.step {
  $screen-sm: 600px;

  .required {
    color: #eb5757;
  }

  &__section--niche-card {
    &__card {
      height: 132px;
      margin-bottom: 16px;
    }
  }

  &__section--niche-card-settings {
    display: flex;
    align-items: center;

    &__item {
      margin-right: 24px;

      &__text {
        margin-left: 24px;

        &--placeholder {
          color: $ui-gray-less-contrast;
          font-size: 12px;
          font-weight: 500;
        }

        &__description {
          color: $ui-gray-less-contrast;
          font-size: 12px;
        }
      }

      &--icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }
    }

    &__title {
      color: $ui-gray-middle;
      font-size: 12px;
      margin-bottom: 4px;
    }

    &__card {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      width: 40px;
      height: 40px;
      padding: 11px;
      background: #ffffff;
      border-radius: 4px;
      box-shadow: 0 4px 10px rgba(43, 45, 52, 0.12);
      cursor: pointer;

      &-bg {
        width: 100%;
        height: 100%;
        border-radius: 2px;
      }
    }

    input {
      position: absolute;
      flex-shrink: 0;
      width: 100%;
      height: 100%;
      opacity: 0;
      z-index: 1;
      cursor: pointer;
    }
  }

  &__section--niche {
    .step__date-container {
      display: flex;
      align-items: center;

      .date-input:not(:last-child) {
        margin-right: 20px;
      }

      @include media($screen-sm) {
        flex-direction: column;

        .date-input:not(:last-child) {
          margin-bottom: 24px;
          margin-right: 0;
        }
      }
    }
  }
}
</style>
